export default {
  STALE_CHECKOUT: 'Checkout does not exist'
};



// WEBPACK FOOTER //
// ./src/constants/ShopifyErrors.js